import React, { useContext } from 'react';
import { IAppContext } from '../client';

export const AppContext = React.createContext<{
  appContext: IAppContext;
}>({
  appContext: {} as IAppContext,
});

export const useAppContext = () => {
  return useContext(AppContext);
};

export const AppContextProvider: React.FC<{
  values: IAppContext;
}> = ({ children, values }) => {
  return (
    <AppContext.Provider
      value={{
        appContext: values,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
